exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-table .closed-icon{color:var(--aluminium-10);font-size:1.2rem;width:unset !important}.cart-table .opened-icon{color:var(--aluminium-30);font-size:1.2rem;width:unset !important}.cart-table .disabled-dropdown-item{color:var(--aluminium-20);cursor:not-allowed}", ""]);

// exports
